import { isCrmObjectType } from './CrmObjectType';
import { isLegacyObjectType } from './LegacyObjectType';
export function isObjectType(s) {
  return isCrmObjectType(s) || isLegacyObjectType(s);
}